import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Loader, fmt, StatusBadge, fmtDateTime, EmptyState } from "@/components/shared";
import { AdminPageHeader, ApproveButton, RejectButton, ImageViewer } from "./adminShared";

const filters = ["all", "pending", "approved", "rejected"];

export default function AdminDeposits() {
  const [items, setItems] = useState(null);
  const [status, setStatus] = useState("pending");

  const load = useCallback(async () => {
    setItems(null);
    const r = await api.get("/admin/deposits", { params: { status } });
    setItems(r.data);
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const approve = async (id) => { try { await api.post(`/admin/deposits/${id}/approve`); toast.success("Deposit approved"); load(); } catch (e) { toast.error(formatApiError(e)); } };
  const reject = async (id, reason) => { try { await api.post(`/admin/deposits/${id}/reject`, { reason }); toast.success("Deposit rejected"); load(); } catch (e) { toast.error(formatApiError(e)); } };

  return (
    <div data-testid="admin-deposits">
      <AdminPageHeader eyebrow="Management" title="Deposits"
        right={<div className="flex gap-2 flex-wrap">{filters.map((f) => (
          <button key={f} data-testid={`deposit-filter-${f}`} onClick={() => setStatus(f)}
            className={`px-4 py-2 rounded-lg text-sm border capitalize transition-colors ${status === f ? "bg-cyan-500/15 border-cyan-500/40 text-cyan-300" : "border-white/10 text-slate-400 hover:border-cyan-500/20"}`}>{f}</button>
        ))}</div>} />
      {items === null ? <Loader /> : items.length ? (
        <div className="glass rounded-2xl p-4 overflow-x-auto">
          <table className="w-full text-sm min-w-[980px]">
            <thead><tr className="text-left text-slate-500 border-b border-white/5">
              {["ID", "User", "Amount", "Network", "Tx Hash", "Screenshot", "Date", "Status", "Actions"].map((h) => <th key={h} className="pb-3 px-2 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.id} className="border-b border-white/5 last:border-0" data-testid={`deposit-row-${d.id}`}>
                  <td className="py-3 px-2 font-mono text-xs text-slate-500">{d.id.slice(0, 8)}</td>
                  <td className="py-3 px-2"><p className="text-slate-200">{d.user_name}</p><p className="text-xs text-slate-500">{d.user_email}</p></td>
                  <td className="py-3 px-2 font-mono text-white">{fmt(d.amount)}</td>
                  <td className="py-3 px-2 text-slate-300">{d.network}</td>
                  <td className="py-3 px-2 font-mono text-xs text-slate-500 max-w-[120px] truncate">{d.transaction_hash}</td>
                  <td className="py-3 px-2"><ImageViewer src={d.screenshot_url} testId={`deposit-screenshot-${d.id}`} /></td>
                  <td className="py-3 px-2 text-slate-500">{fmtDateTime(d.created_at)}</td>
                  <td className="py-3 px-2"><StatusBadge status={d.status} />{d.rejection_reason && <p className="text-xs text-red-400 mt-1 max-w-[140px]">{d.rejection_reason}</p>}</td>
                  <td className="py-3 px-2">
                    {d.status === "pending" ? (
                      <div className="flex gap-2">
                        <ApproveButton testId={`deposit-approve-${d.id}`} onConfirm={() => approve(d.id)} />
                        <RejectButton testId={`deposit-reject-${d.id}`} onConfirm={(r) => reject(d.id, r)} />
                      </div>
                    ) : <span className="text-xs text-slate-600">by {d.reviewed_by || "-"}</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : <EmptyState title="No deposits" subtitle={`No ${status} deposits found.`} />}
    </div>
  );
}
